import { captureException } from "./plugins/sentry";
import { deviceModule } from "./store/device";
import { masterStore } from "./store/master";
import { now } from "./utils/date";

let pauseTime: number | null = null;
const COMMIT_VERSION_LENGTH = 8;

async function fetchVersionFromRemote() {
  const res = await fetch(`/latest-version?${now()}`);
  const value = await res.text();
  return value?.length === COMMIT_VERSION_LENGTH ? value : null;
}
export function fetchVersionFromDocument() {
  const el = document.querySelector('meta[name="commit"]');
  const value = el?.getAttribute("value");
  return value?.length === COMMIT_VERSION_LENGTH ? value : null;
}

export async function updateIfNewerVersionExists() {
  const nowValue = now();
  const lastUpdateCheckTime = localStorage.getItem("lastUpdateCheckTime");
  // 万が一index.htmlがキャッシュされてしまった場合に無限ループになるのを防ぐため
  // 3分以内に更新チェックを行っていたらスキップする
  if (
    lastUpdateCheckTime &&
    nowValue - parseInt(lastUpdateCheckTime, 10) < 3 * 60 * 1000
  ) {
    return;
  }
  localStorage.setItem("lastUpdateCheckTime", nowValue.toString());
  const version = fetchVersionFromDocument();
  try {
    const latestVersion = await fetchVersionFromRemote();
    if (latestVersion && version) {
      if (latestVersion !== version) {
        location.reload();
        return;
      } else {
        // すでに最新のバージョンになっている場合には何もしない
      }
    } else {
      console.log("バージョン情報が取得できませんでした");
    }
  } catch {
    // 通信できない場合には何もしない
    return;
  }
}

function onResume() {
  // pauseしてから30秒経っていなかったら更新しない
  if (!!pauseTime && now() - pauseTime < 30 * 1000) {
    return;
  }

  try {
    updateIfNewerVersionExists();
  } catch (e) {
    captureException(e as Error);
  }
  try {
    masterStore.fetchMaster();
  } catch (e) {
    captureException(e as Error);
  }
}

function recordPauseTime() {
  pauseTime = now();
}

export function registerAppUpdator() {
  if (deviceModule.isBrowser) return;
  document.addEventListener("pause", recordPauseTime);
  document.addEventListener("resume", onResume);
}
